export const ApplicationsFilters = [    
    {
        id: "isapproved",
        type: "togglegroup",
        options: [
            {
                id: '0',
                name: 'Not Approved'
            },
            {
                id: '1',
                name: 'Is Approved'
            }
        ]
    },
    {
        id: "inprogress",
        type: "togglegroup",
        options: [
            {
                id: '0',
                name: 'Not In Progress'
            },
            {
                id: '1',
                name: 'In Progress'
            }
        ]
    },
    {
        id: "autoapproved",
        type: "togglegroup",
        options: [
            {
                id: '0',
                name: 'Manual'
            },
            {
                id: '1',
                name: 'Automatic'
            }
        ]
    }
];